<p-iconField [iconPosition]="$iconPosition()" [ngClass]="$class()">
  <ng-content></ng-content>
</p-iconField>
